{
  "page_Helseregistre_NavigateBackLinkTitle": "Go to Health registries",
  "page_Samvalg_NavigateBackLinkTitle": "Shared decision-making",
  "page_Samvalg_NavigateBackLinkURL": "{HelsenorgeUrl}/samvalg",
  "page_VelgBehandlingssted_NavigateBackLinkTitle": "Choose a treatment centre",
  "page_Behandlinger_NavigateBackLinkTitle": "Treatments"
}
